import Route from "@mapmycustomers/shared/types/entity/Route";
import RouteDetail from "@mapmycustomers/shared/types/entity/RouteDetail";
import UpdateRoutePayload from "@mapmycustomers/shared/types/entity/UpdateRoutePayload";
import User from "@mapmycustomers/shared/types/User";

export type RoutePatch = Partial<Pick<Route, "color" | "name" | "userIds">> & {
  routeDetail?: Partial<RouteDetail>;
  user?: { id: User["id"] };
};

type RoutePayloadDetail = UpdateRoutePayload["routeDetail"];

type StartLocation =
  | Pick<RouteDetail, "startAddress" | "startGeoPoint">
  | Pick<RouteDetail, "startEntity">;

type EndLocation = Pick<RouteDetail, "endAddress" | "endGeoPoint"> | Pick<RouteDetail, "endEntity">;

const buildStartLocation = (routeDetail: RouteDetail): StartLocation | undefined => {
  if (routeDetail.startEntity) {
    return { startEntity: routeDetail.startEntity };
  }
  if (routeDetail.startAddress !== null && routeDetail.startGeoPoint !== null) {
    return {
      startAddress: routeDetail.startAddress,
      startGeoPoint: routeDetail.startGeoPoint,
    };
  }
  return undefined;
};

const buildEndLocation = (routeDetail: RouteDetail): EndLocation | undefined => {
  if (routeDetail.endEntity) {
    return { endEntity: routeDetail.endEntity };
  }
  if (routeDetail.endAddress !== null && routeDetail.endGeoPoint !== null) {
    return {
      endAddress: routeDetail.endAddress,
      endGeoPoint: routeDetail.endGeoPoint,
    };
  }
  return undefined;
};

const buildRouteDetail = (
  routeDetail: RouteDetail,
  patch: Partial<RouteDetail> | undefined
): RoutePayloadDetail => {
  const startLocation = buildStartLocation(routeDetail);
  const endLocation = buildEndLocation(routeDetail);
  return {
    id: routeDetail.id,
    allottedTime: routeDetail.allottedTime,
    startAt: routeDetail.startAt,
    travelMode: routeDetail.travelMode,
    type: routeDetail.type,
    ...startLocation,
    ...endLocation,
    ...patch,
  } as RoutePayloadDetail;
};

const mergeRoute = (route: Route, patch: RoutePatch): UpdateRoutePayload => {
  const { routeDetail: patchRouteDetail, ...patchRest } = patch;
  return {
    id: route.id,
    color: route.color,
    name: route.name,
    userIds: route.userIds,
    ...patchRest,
    routeDetail: buildRouteDetail(route.routeDetail, patchRouteDetail),
  };
};

export default mergeRoute;
